<template>
    <div class="text-margin">
        <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
            v-model="paramValue">
        </el-input>
        <el-button type="primary" @click="setParam">set_param</el-button>
    </div>
</template>

<script>
import request from "../../api/request"
export default {
    data() {
        return {
            paramValue: ''
        }
    },
    created(){
        this.getParam()
    },
    mounted(){
    },
    methods: {
        getParam(){
            let that = this
            request.vm
                .post('vm/global_param_get', {})
                .then(resp => {
                    that.paramValue = JSON.stringify(resp.data,null,4)             
                })
                .catch(error => {
                    console.log(error)
                })
        },
        setParam(){
            let that = this
            if(!this.isJSON(that.paramValue)){
                this.$message.error("请检查格式是否正确")
                return
            }
            request.vm
                .post('vm/global_param_set', {
                    param: JSON.parse(that.paramValue)
                })
                .then(() => {
                    this.$message.success("设置成功")
                })
        },
        isJSON(str) {
            if (typeof str == 'string') {
                try {
                    var obj=JSON.parse(str);
                    if(typeof obj == 'object' && obj ){
                        return true;
                    }else{
                        return false;
                    }

                } catch(e) {
                    console.log('error：'+str+'!!!'+e);
                    return false;
                }
            }
        }
    }
}
</script>

<style scoped>
    .text-margin{
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
    .el-textarea{
        margin-bottom: 20px;
    }
</style>
